export enum ProductType {
  Past = 'Past',
  All = 'All',
  Alternative = 'Alternative',
}
